<template>
  <div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <HeaderSagres titulo="Comunicações eletrônicas" />
      </template>
      <b-card-body class="p-0">
        <CardFiltrosBusca class="m-3">
          <div class="filtrosWrapper d-flex align-items-center justify-content-around">
            <BFormInput v-model="filtroCP" placeholder="Busque por texto" autocomplete="off" data-1p-ignore
              debounce="300" class="buscaTexto mt-2" />
            <DateRangePickerBase v-model="filtroDtNotificacao" title="Data de Notificação" />
          </div>
        </CardFiltrosBusca>
        <b-table :busy="isBusy" :fields="fields" hover no-border-collapse :items="filteredItems" :sort-desc="true" small
          show-empty stacked="lg" class="mb-0">
          <template #empty>
            <span>Não há comunicações eletrônicas.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados comunicações com estes filtros.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template #cell(Notificado)="row">
            <span :key="row.item.CodProtocolo" :title="row.value">{{
              truncateText(row.value)
            }}</span>
          </template>
          <template #cell(Notificacao)="row">
            <b-link @click="abrirDetalhes(row.item)" v-if="row.item.PermiteResposta">
              {{ row.item.Notificacao }}
            </b-link>
            <span v-else>{{ row.item.Notificacao }}</span>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="actions-icons">
              <b-link class="text-dark" v-if="podeResponder(row.item)" :key="row.item.CodProtocolo"
                @click="responderAComunicacaoEletronica(row.item)">
                <font-awesome-icon icon="edit" />
                <span class="texto-botao">Responder</span>
              </b-link>
            </div>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import protocoloService from "@/services/processos-eletronicos/protocoloService";
import { store } from "@/store";
import { UtilsTS } from '@/utilsts';
import { tableFieldsComunicacoesProcessuais } from "@/types/processo-eletronico/table-fields-comunicacoes-processuais";
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue';
import HeaderSagres from '@/components/shared/HeaderSagres.vue';
import DateRangePickerBase from '@/components/shared/DateRangePickerBase.vue';
// import { isAdmin } from "@/store";

export default {
  name: "ComunicacoesEletronicas",
  components: { CardFiltrosBusca, DateRangePickerBase, HeaderSagres },
  mixins: [UtilsTS],
  data() {
    return {
      fields: tableFieldsComunicacoesProcessuais,
      filtroCP: '',
      filtroDtNotificacao: { startDate: null, endDate: null },
      isBusy: false,
      items: [],
    };
  },
  computed: {
    filteredItems() {
      const ft = this.filtroCP.trim().toLowerCase()
      const filtradosTexto = !ft.length ? this.items : this.items.filter(i => i.textos.some(t => t.includes(ft)));
      if (this.filtroDtNotificacao.startDate !== null && this.filtroDtNotificacao.endDate !== null) {
        return filtradosTexto.filter(i => i.DataPublicacao >= this.filtroDtNotificacao.startDate && i.DataPublicacao <= this.filtroDtNotificacao.endDate)
      }
      return filtradosTexto
    },
    // isADM() {
    //   return isAdmin();
    // }
  },
  async mounted() {
    await this.getComunicacoesEletronicas();
  },
  methods: {
    async getComunicacoesEletronicas() {
      try {
        this.isBusy = true;
        const response = store.codigoUG ? await protocoloService.listarComunicacoesEletronicasUsuarioUG() : await protocoloService.listarComunicacoesEletronicasUsuario();
        //console.log(response.data);
        if (response && response.status == 200 && response.data.Notificacoes) {
          const nots = response.data.Notificacoes.map((n) => {
            //A regra de negócio para o campo dataResposta é a seguinte: 
            //Se vier DataResposta, é ela. 
            //Caso não venha, a prioridade é o campo DataRespostaPrazo
            //Caso não venha também, tem que mandar null.
            return {
              ...n,
              DataNotificacao: this.formatData(n.DataNotificacao),
              DataPublicacao: new Date(n.DataPublicacao),//this.formatData(n.DataPublicacao),
              DataResposta: (n.DataResposta ?? n.DataRespostaPrazo) !== null ? new Date(n.DataResposta ?? n.DataRespostaPrazo) : null,//this.formatData(n.DataResposta ?? n.DataRespostaPrazo),
              prazoVencimento: this.montarPrazoVencimento(n),
              _rowVariant: this.podeResponder(n) ? "" : "secondary",
              textos: [
                n.Notificacao?.toLowerCase(),
                n.CodTCE?.toLowerCase(),
                n.DescricaoTipoNotificacao?.toLowerCase(),
                n.Descricao?.toLowerCase(),
                n.Notificado?.toLowerCase()
              ]
            };
          })
          const pr = nots.filter(a => this.podeResponder(a))
          const npr = nots.filter(a => !this.podeResponder(a))
          this.items = [...pr, ...npr]
        } else {
          this.$toast.error("Erro ao obter as comunicações eletrônicas.");
        }
      } catch (err) {
        console.error("Erro ao obter as comunicações eletrônicas: ", err);
        this.$toast.error(err.message);
      } finally {
        this.isBusy = false;
      }
    },
    abrirDetalhes(notificacao) {
      this.$router.push({
        name: "detalhes-comunicacao-eletronica",
        params: { notificacao },
      });
    },
    /**
     * Monta o texto completo de "Prazo para Vencimento". 
     * Atualizado em 20220706
     */
    montarPrazoVencimento(notificacao) {
      let texto = ''
      if (notificacao.Prazo) {
        texto = notificacao.Prazo + ' dias'
      }
      if (notificacao.DataInicioPrazo && notificacao.DataFimPrazo) {
        if (texto.length) texto = texto + ' '
        texto = texto + `(${this.formatData(notificacao.DataInicioPrazo)} a ${this.formatData(notificacao.DataFimPrazo)})`
      }
      return texto
    },
    podeResponder(notificacao) {
      return notificacao.PermiteResposta && !notificacao.DataResposta && !notificacao.DataRespostaPrazo
    },
    responderAComunicacaoEletronica(notif) {
      this.$router.push({
        name: "ResponderComunicacaoEletronica",
        params: { notificacao: notif },
      });
    },
  },
};
</script>
<style scoped>
.buscaTexto {
  max-width: 15rem;
}

::v-deep div.vue-daterange-picker {
  min-width: 15rem;
}

@media screen and (max-width: 768px) {
  .filtrosWrapper {
    flex-direction: column;
  }

  div.filtrosWrapper fieldset.form-group {
    margin-top: 1rem;
  }
}

@media screen and (max-width: 400px) {
  ::v-deep div.vue-daterange-picker {
    min-width: 10rem;
  }
}
</style>